"use strict";

module.exports = function (accumulator, order, product, component, options) {
  return (parseFloat(accumulator, 10) || 0) + options.linePrice * parseInt(component.quantity, 10);
};